import React from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import MobileDashboard from './mobile/MobileDashboard';
import DesktopDashboard from './desktop/DesktopDashboard';

const DashboardPage: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      {isMobile ? <MobileDashboard /> : <DesktopDashboard />}
    </>
  );
};

export default DashboardPage;
